// Import the functions you need from the Firebase SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Import Firestore
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import {getStorage} from "@firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD9-t7hapn_IQiFpzN6ZUPBeUN6a-xddpA",
    authDomain: "hersoid-slot-machine.firebaseapp.com",
    projectId: "hersoid-slot-machine",
    storageBucket: "hersoid-slot-machine.firebasestorage.app",
    messagingSenderId: "863348354214",
    appId: "1:863348354214:web:eb5857a54cff66fe1d1867",
    measurementId: "G-4BE8Z07KS2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
